import createIcon from '../../createIcon';

/**
 * @component @name MilitaryTech
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTAuNDNWMkg3VjEwLjQzQzcgMTAuNzggNy4xOCAxMS4xMSA3LjQ5IDExLjI5TDExLjY3IDEzLjhMMTAuNjggMTYuMTRMNy4yNyAxNi40M0w5Ljg2IDE4LjY3TDkuMDcgMjJMMTIgMjAuMjNMMTQuOTMgMjJMMTQuMTUgMTguNjdMMTYuNzQgMTYuNDNMMTMuMzMgMTYuMTRMMTIuMzQgMTMuOEwxNi41MiAxMS4yOUMxNi44MiAxMS4xMSAxNyAxMC43OSAxNyAxMC40M1pNMTMgMTIuMjNMMTIgMTIuODNMMTEgMTIuMjNWM0gxM1YxMi4yM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MilitaryTech = createIcon('MilitaryTech', [
  [
    'path',
    {
      d: 'M17 10.43V2H7V10.43C7 10.78 7.18 11.11 7.49 11.29L11.67 13.8L10.68 16.14L7.27 16.43L9.86 18.67L9.07 22L12 20.23L14.93 22L14.15 18.67L16.74 16.43L13.33 16.14L12.34 13.8L16.52 11.29C16.82 11.11 17 10.79 17 10.43ZM13 12.23L12 12.83L11 12.23V3H13V12.23Z',
      key: '1g26n1',
    },
  ],
]);

export default MilitaryTech;
